/** Format as currency: $123.45, or '—' if null/undefined */
export function formatCurrency(value: number | null | undefined): string {
    if (value == null) return '—';
    return `$${Number(value).toFixed(2)}`;
}

/** Format as percentage with sign: +2.34% or -1.50% */
export function formatPercent(value: number | null | undefined, decimals = 2): string {
    if (value == null) return '—';
    const sign = value > 0 ? '+' : '';
    return `${sign + value.toFixed(decimals)}%`;
}

/** Colour class for a signed value: green above zero, red below, dim at zero. */
export const plClass = (value: number): string =>
    value > 0 ? 'text-green' : value < 0 ? 'text-red' : 'text-dim';
